'use client' // Error components must be Client components

import { useEffect } from 'react'
import Link from 'next/link'
import Header from '../components/header'
import Footer from '../components/footer'

export default function NotFound({
  error,
}: {
  error: Error
  reset: () => void
}) {
  useEffect(() => {
    // Log the error to an error reporting service
    console.error(error)
  }, [error])

  const banner: boolean = true

  return (
    <div className="w-full">
      <Header banner={banner} />
      <div className="grid min-h-full place-items-center bg-white px-6 py-24 sm:py-32 lg:px-8">
        <div className="text-center">
          <p className="text-base font-semibold text-primary text-8xl">404</p>
          <h1 className="mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-5xl">
            Page not found
          </h1>
          <p className="mt-6 text-base leading-7 text-gray-600">
            Sorry, we couldn’t find the page you’re looking for.
          </p>
          <div className="mt-10 flex items-center justify-center gap-x-6">
            <Link
              href="/"
              className="inline-block rounded-md border border-transparent bg-secondary px-8 py-3 text-center font-medium text-white hover:bg-secondary-hover"
            >
              Back
            </Link>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  )
}
